export default __webpack_public_path__ + "static/media/atlantis1.4d83823f.jpg";